<template>
  <div class="dropdown-container" :class="{open}">
    <div class="dropdown-header" @click="open = !open">
      {{active || placeholder}}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 17 10"
      >
        <path
          fill="none"
          fill-rule="evenodd"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15.142 1.071l-7.07 7.071L1 1.072"
        ></path>
      </svg>
    </div>
    <transition enter-active-class="noop" leave-active-class="noop">
      <div
        v-show="open"
        class="staggered-scroll"
        :style="{height: `${pxToVw(itemHeight * maxShowNum)}vw`}"
      >
        <transition-group class="staggered-list" name="staggered" tag="ul">
          <li
            class="item"
            v-for="(v, i) of computedList"
            :key="getKey(v, matchKey)"
            @click="handleClick(v)"
            :style="{animationDelay: `${(!open ? (list.length - i) : (i + 1)) * .03}s`}"
          >
            <slot :item="v">{{getKey(v, showKey)}}</slot>
          </li>
        </transition-group>
      </div>
    </transition>
    <transition name="staggered">
      <div
        v-show="open"
        class="animate-bg"
        :style="{height: `${pxToVw(itemHeight * maxShowNum + 44)}vw`}"
      ></div>
    </transition>
    <transition name="fade">
      <div v-show="open" class="mask"></div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    value: {
      required: true
    },
    showKey: {
      type: String
    },
    matchKey: {
      type: String
    },
    maxItem: {
      type: Number,
      default: 10
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    itemHeight: {
      type: Number,
      default: 56
    }
  },
  data() {
    return {
      open: false
    }
  },
  computed: {
    active() {
      const { list, value, showKey, matchKey } = this
      if (!list) return ''
      const find = list.find(v => value === this.getKey(v, matchKey))
      return find ? this.getKey(find, showKey) : ''
    },
    computedList() {
      return this.open ? this.list : []
    },
    maxShowNum() {
      return Math.min(this.list.length, this.maxItem)
    }
  },
  methods: {
    handleClick(v) {
      this.$emit('input', this.getKey(v, this.matchKey))
      this.open = false
    },
    getKey(v, key) {
      return key ? v[key] : v
    },
    pxToVw(px) {
      return (px / 375) * 100
    }
  }
}
</script>
<style lang="stylus" scoped>
.dropdown-container
  position relative
  top -1px
  transition all 0.5s
.dropdown-header
  box-shadow 0px 2px 8px 0px rgba(101, 113, 117, 0.1)
  color #333
  padding-left 15px
  padding-right 15px
  z-index 11
  background-color #fff
  position relative
  display flex
  font-size 16px
  font-weight bold
  align-items center
  justify-content space-between
  height 44px
  svg
    cursor pointer
    width 17px
    height 10px
    transition transform 0.2s ease-in-out
.staggered-scroll
  position absolute
  padding 0 15px
  margin-top 44px
  overflow-y scroll
  width 100%
  top 0
  left 0
  z-index 10
  transition background-color 0.2s ease
  background-color white
.staggered-list
  .item
    line-height 55px
    font-size 16px
    color #333
    &:not(:last-child)
      border-bottom 1px solid #f6f6f6
.open
  svg
    transform rotate(-180deg)
  .staggered-list
    background-color transparent
  .dropdown-header
    box-shadow none
.staggered-enter-active
  animation-fill-mode both
  animation-duration 0.5s
.staggered-leave-active
  animation-fill-mode both
  animation-duration 0.5s
.staggered-enter-active
  animation-name bounceInDown
.staggered-leave-active
  animation-name bounceOutUp
@keyframes bounceInDown
  0%, 60%, 75%, 90%, to
    animation-timing-function cubic-bezier(0.215, 0.61, 0.355, 1)
  0%
    opacity 0
    transform translate3d(0, -3000px, 0)
  60%
    opacity 1
    transform translate3d(0, 25px, 0)
  75%
    transform translate3d(0, -10px, 0)
  90%
    transform translate3d(0, 5px, 0)
  to
    transform none
.bounceInDown
  animation-name bounceInDown
@keyframes bounceOutUp
  20%
    transform translate3d(0, -10px, 0)
  40%, 45%
    opacity 1
    transform translate3d(0, 20px, 0)
  to
    opacity 0
    transform translate3d(0, -2000px, 0)
.bounceOutUp
  animation-name bounceOutUp
.animate-bg
  box-shadow 0px 2px 8px 0px rgba(101, 113, 117, 0.1)
  background-color white
  position absolute
  padding-top 44px
  width 100%
  top 0
  left 0
  z-index 9
.mask
  position fixed
  top 0
  right 0
  bottom 0
  left 0
  z-index 8
  background-color #000
  opacity 0.6
@keyframes noop
  from , to
.noop
  animation-name noop
  animation-duration 0.5s
</style>
